module.exports = __webpack_public_path__ + "img/fguoz.674aca3a.svg";